import { IronCheckedElementBehavior } from '@polymer/iron-checked-element-behavior/iron-checked-element-behavior.js';
import { IronButtonState } from '@polymer/iron-behaviors/iron-button-state.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { IronControlState } from '@polymer/iron-behaviors/iron-control-state.js';

export const COMCheckedElementBehavior = function(superClass) {

  return class extends mixinBehaviors([
    IronButtonState,
    IronControlState,
    IronCheckedElementBehavior
  ], superClass) {

    static get properties() {
      return {
        tabindex: Number,
        ariaChecked: String,
        ariaActiveAttribute: String,
        checked: Boolean,
        noink: Boolean,
        error: Boolean,
        disabled: Boolean,
        hover: Boolean,
        keyboardNavigation: {
          type: Boolean,
          notify: true,
          reflectToAttribute: true
        }
      };
    }

    ready() {
      super.ready();

      /**
       * @desc for mobile devices, prevent focus when tapping outside of selection radius
       * mousedown radius is larger than touchstart radius
       * causes weird behavior in which input is focused but not selected
       * @see https://stackoverflow.com/q/30513829
       */
      this.addEventListener('mousedown', (event) => {
        if (event.sourceCapabilities && event.sourceCapabilities.firesTouchEvents) {
          event.preventDefault();
        }
      });

      this.addEventListener('keyup', (event) => this.keyboardNavigation = true);
      this.addEventListener('blur', (event) => this.keyboardNavigation = false);
    }

    /**
     * @desc Set class for the element state or behavior
     * @param {Boolean} checked
     * @param {Boolean} disabled
     * @param {Boolean} error
     * @param {Boolean} hover
     * @return {String} className
     */
    computeElementClass(checked, disabled, error, hover) {
      var className = '';
      if (checked) {
        className += ' checked';
      }
      if (disabled) {
        className += ' disabled';
      }
      if (error) {
        className += ' error';
      }
      if (hover) {
        className += ' hover';
      }

      return className;
    }

    /**
     * @desc Synchronizes the element's `active` and `checked` state
     */
    _buttonStateChanged() {
      this.toggles = true;
      this.setAttribute('aria-disabled', false);
      this.setAttribute('aria-checked', this.checked);

      if (this.disabled) {
        this.setAttribute('aria-checked', this.checked);
        this.setAttribute('aria-disabled', true);
        this.active = false;
        this.toggles = false;
        this.focused = false;
        return;
      }

      if (this.isAttached) {
        this.checked = this.active;
      }
    }

  };
};
